<template>
  <div class="wage-check-manage-main">
    <el-row class="query-condition">
      <!-- <el-select v-model="params.isAuditStatus" @change="getData">
        <el-option :value="false" label="待审批"></el-option>
        <el-option :value="true" label="已审批"></el-option>
      </el-select>
      <el-date-picker v-model="salaryMonthRange" type="monthrange" align="right" unlink-panels range-separator="至"
        start-placeholder="开始月份" end-placeholder="结束月份" value-format="YYYY-MM"
        @change="salaryMonthRangeChange" style="margin-right: 15px;width: 250px;">
      </el-date-picker> -->
      <el-input v-model="params.name" placeholder="输入姓名搜索" @change="searchData" clearable></el-input>
      <el-input v-model="params.idCardNo" placeholder="输入身份证号搜索" @change="searchData" clearable></el-input>
      <el-input v-model="params.phone" placeholder="输入手机号搜索" @change="searchData" clearable></el-input>
      <el-button type="primary" @click="searchData"><el-icon><search/></el-icon>搜索</el-button>
      <el-button type="warning" @click="resetSearch"><el-icon><refresh/></el-icon>重置</el-button>
    </el-row>
    <div style="padding-top:1%;">
      <el-button type="primary" @click="exportHmdList()"><el-icon><download /></el-icon>导出</el-button>
    </div>
    <el-table :data="tableData" tooltip-effect="dark" border stripe height="calc(100vh - 215px)"  v-loading="loading">
      <el-table-column type="selection" label="序号" width="50" />
      <el-table-column label="姓名" width="120">
          <template #default="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column label="性别" width="60">
          <template #default="scope">{{ scope.row.sex }}</template>
      </el-table-column>
      <el-table-column label="身份证号" width="180">
          <template #default="scope">{{ scope.row.idCardNo }}</template>
      </el-table-column>
      <el-table-column label="手机号" width="120">
          <template #default="scope">{{ scope.row.phone }}</template>
      </el-table-column>
      <el-table-column label="家庭住址" width="500">
          <template #default="scope">{{ scope.row.address }}</template>
      </el-table-column>
      <el-table-column label="影响等级" width="90">
          <template #default="scope">{{ getLevelName(scope.row.levelId) }}</template>
      </el-table-column>
      <el-table-column label="影响年限" width="90">
          <template #default="scope">{{ getLevelYear(scope.row.levelId) }}</template>
      </el-table-column>
      <el-table-column label="有效时间" width="180">
          <template #default="scope">{{ scope.row.dateRange }}</template>
      </el-table-column>
      <el-table-column label="列入事由">
          <template #default="scope"><div class="hdmTableTd" :title="scope.row.reason">{{ scope.row.reason }}</div></template>
      </el-table-column>
      <el-table-column label="群组">
          <template #default="scope"><div style="" :title="scope.row.fullGroup">{{scope.row.fullGroup }}</div>
            <!-- {{ scope.row.projectName }}{{scope.row.teamName?'/'+scope.row.teamName:''}}{{scope.row.groupName?'/'+scope.row.groupName:''}} -->
          </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="scope">
          <div style="display:flex;justify-content:center;padding: 0 15px;">
            <el-button size="small" type="primary" @click="toDetail(scope.row)">详情</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
      :current-page="params.pageNo" :page-size="params.length" @current-change="pageNoChange"
      @size-change="lengthChange">
    </el-pagination>
  </div>

  <!-- <Add :editData="editData" :getData="getData" :detailVisible="isAddDrawer" /> -->
  <el-drawer title="" v-model="isDetailDrawer" :close-on-click-modal="false" destroy-on-close size="40%">
    <template #title>
      <span class="import-title">不良记录人员详情（工人）</span>
    </template> 
    <div class="main-center">
      <Detail :editData="detailObj"></Detail>
    </div>
    <template #footer>
      <div class="approval-footer" style="display: flex;justify-content: center;">
        <el-button @click="isDetailDrawer =false">关闭</el-button>
      </div>
    </template>
  </el-drawer>
</template>
<script>
import { defineComponent } from 'vue'
import { heimindanList,listByCondition,downFile,expHmdList} from '@/api/heimingdan/heimingdan';
import { getItemByTypeCode} from '@/api/sys/item';
import Detail from './Detail.vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import { isHaveOrgPower,requestPrefix } from '@/utils/common';
import { formatDate } from "@/utils/datetime";
import { exportFile } from '@/utils/fileUtil';
export default defineComponent({
  components: { Detail },
  data() {
    return {
      loading: false,
      total: 0,
      params: {
        pageNo: 1,
        length: 20,
        idCardNo: null, 
        phone: null,
        name: null,
        approvalStatus:1,
      },
      addLoading: false,
      userParam:{
        name:null,
        idCardNo:null,
        phone:null
      },
      //列表数据
      tableData: [],

      //添加抽屉
      isDetailDrawer: false,
      detailObj: {},
      levelList:[],
      orgList:[],
      pjtList:[],
      groupList:[],
      teamList:[],
    }
  },
  mounted() {
    this.getLevelList();
    this.getData();
  },
  methods: {
    //默认获取待审数据
    getData() {
      this.loading = true;
      heimindanList(this.params).then((rep) => {
        this.loading = false;
        if(rep&&rep.data&&true==rep.data.status){
          this.tableData = rep.data.data.data;
          this.total = rep.data.data.page.totalRecords;
        }else{
          ElMessage({
              type: 'error',
              message: data.msg?data.msg:'获取列表失败',
          });
        }
      }).catch(_ => this.loading = false);
    },
    searchData() {
      this.params.pageNo = 1;
      this.getData();
    },
    pageNoChange(pageNo) {
      this.params.pageNo = pageNo;
      this.getData();
    },
    lengthChange(length) {
      this.params.length = length;
      this.searchData();
    },
    resetSearch(){
      this.params.name=null;
      this.params.idCardNo=null;
      this.params.phone=null;
      this.searchData();
    },
    //表格多选选中事件
    selectionChange(val){
        this.multipleSelection=val;
    },
    editHeimingdan(row) {
      this.editData=row;
      this.isAddDrawer=true;
    },
    
    //查看详情
    toDetail(row) {
      this.detailObj=row;
      this.detailObj.fileList=[];
      if(row.attrPaths){
        let fA=row.attrPaths.split(',');
        if(fA.length>0){
          for(let path of fA){
            if(path){
              let param={attrPaths:path},name=path.substring(path.lastIndexOf("\\")+1);
              downFile(param).then((rep)=>{console.log('downFile',rep);
                this.detailObj.fileList.push({name,url:URL.createObjectURL(rep.data),fi:{name,size:rep.data.size,path},fObj:rep.data});
              });
            }
          }
        }
      }
      this.isDetailDrawer=true;
    },
    impPreview(file) {
        console.log(file);
    },
    getLevelList(){
      getItemByTypeCode("blackList").then(({data}) => {//console.log('getLevelList',data);
        this.levelList = data.data;
      })
    },
    //时间类型转换
    dateFormat(cellValue) {
      return formatDate(cellValue, 'yyyy-MM-dd HH:mm:ss');
    },
    getLevelName(levelId){
      if(!levelId){
        return "";
      }
      for(var l of this.levelList){
        if(levelId==l.id){
          return l.name;
        }
      }
      return "";
    },
    getLevelYear(levelId){
      if(!levelId){
        return "";
      }
      for(var l of this.levelList){
        if(levelId==l.id){
          return l.yearLength;
        }
      }
      return "";
    },
    exportHmdList(){
      expHmdList(this.params).then(rep=>{
        exportFile(rep,"黑名单花名册_"+new Date().getTime()+".xlsx");
      }).catch(_ =>{
        ElMessage({
          type: 'error',
          message: '导出失败',
        });
        console.log(_);
      });
    }
  }
})
</script>

<style lang="scss" scoped>
.wage-check-manage-main {
  padding: 15px;
  .query-condition {
    .el-select,
    .el-input {
      margin-right: 15px;
    }
    .el-select {
      width: 120px;
    }
    .el-input {
      width: 200px;
    }
  }
  .el-table {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
/deep/ .el-form-item__content{
  width: 100%;
}
/deep/ .hdmTableTd{
  max-height: 5vh;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>